/**
 * The slugs of the general category: the iTunes root genre, which holds every podcast of a market and which its store names
 * in its own language ("Poddar" in Sweden). It says nothing about a podcast, so lists and breadcrumbs leave it out when
 * the podcast has a category of its own. "podcaster" is the name an older catalogue used.
 *
 * This is the one place that knows the names. Another market adds its root genre here until the API says which category is
 * the general one (a flag on the category) and the names go away.
 */
const GENERAL_SLUGS = ["poddar", "podcaster"];

type CategoryLike = { slug?: string | null; name?: string | null };

/** Whether a category is the general one. The slug decides; a category without one is compared by its name. */
export const isGeneralCategory = (category: CategoryLike): boolean => {
    const key = (category.slug || category.name || "").toLowerCase();
    return GENERAL_SLUGS.includes(key);
};

/** The categories that say something about a podcast: all but the general one */
export const ownCategories = <T extends CategoryLike>(categories: T[] | null | undefined): T[] =>
    (categories ?? []).filter((category) => !isGeneralCategory(category));
